<script>
    import CRUD from './CRUD.svelte';
    import ChangePasswordModal from '../components/ChangePasswordModal.svelte';
    import { 
        fetchUsers, 
        saveUser, 
        removeUser, 
        searchUsers, 
        subscribeToUsers, 
        unsubscribeFromUsers 
    } from '../controllers/userController.js';
    import { fetchRoles } from '../controllers/roleController.js'; // Función para cargar roles
    import { onMount } from 'svelte';

    let userColumns = [
        { label: 'ID', field: 'id', type: 'text' },
        { label: 'Email', field: 'email', type: 'text' },
        { label: 'Nombre', field: 'name', type: 'text' },
        { label: 'Rol', field: 'role', type: 'text' },
        { label: 'Verificado', field: 'verified', type: 'bool' },
        { label: 'Avatar', field: 'avatar', type: 'image' },
    ];

    let newUser = {
        id: '',
        email: '',
        emailVisibility: true,
        verified: false,
        name: '',
        avatar: '',
        role: '',
        password: '', // Required for new users
    };

    let editColumns = [
        { label: 'Email', key: 'email', type: 'text', required: true },
        { label: 'Nombre', key: 'name', type: 'text', required: true },
        { label: 'Rol', key: 'role', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Verificado', key: 'verified', type: 'checkbox' },
        { label: 'Avatar', key: 'avatar', type: 'file' },
    ];

    // Opciones de roles
    let roleOptions = [];

    // Función para cargar y transformar roles
    async function loadRoles() {
        try {
            const fetchedRoles = await fetchRoles();

            if (Array.isArray(fetchedRoles.role)) {
                roleOptions = fetchedRoles.role.map(e => ({
                    key: e[editColumns.find(col => col.key === 'role').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'role').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'role').options = roleOptions;
            } else {
                console.error('Se esperaba un array de roles, pero se obtuvo:', fetchedRoles);
            }
        } catch (error) {
            console.error('Error al cargar las roles:', error);
        }
    }

    let showPasswordModal = false;
    let selectedUserId = '';

    function handlePasswordChange(userId) {
        selectedUserId = userId;
        showPasswordModal = true;
    }

    function handleClosePasswordModal() {
        showPasswordModal = false;
        selectedUserId = '';
    }

    // Add action buttons to the CRUD component
    let actionButtons = [
        {
            label: 'Cambiar Contraseña',
            icon: '🔑',
            onClick: handlePasswordChange
        }
    ];

    onMount(() => {
        loadRoles();  // Cargar los roles al montar el componente
    });
</script>

<CRUD 
    title="Usuarios"
    entityName="users"
    newEntity={newUser}
    columns={userColumns}
    fetchEntities={fetchUsers}
    saveEntity={saveUser}
    removeEntity={removeUser}
    searchEntities={searchUsers}
    subscribeToChanges={subscribeToUsers}
    unsubscribeFromChanges={unsubscribeFromUsers}
    editColumns={editColumns}
    onPasswordChange={handlePasswordChange}
/>

<ChangePasswordModal 
    show={showPasswordModal}
    userId={selectedUserId}
    on:close={handleClosePasswordModal}
/>